module.exports = __webpack_public_path__ + "static/walter-payton-0bcf08532a15253ebb5adac2e3c302cf.jpeg";